import { useCookies } from "react-cookie";
import { COOKIE_HANBIRO_GW } from "base/constant/cookies";

export default function useAuth() {
  const [cookies] = useCookies();
  let isLoggedIn = false;

  if (cookies?.[COOKIE_HANBIRO_GW]) {
    isLoggedIn = true;
  }

  return { isLoggedIn };
}
